import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
} from "@chakra-ui/react";

const ChakraVolumeSlider = ({ value, onChange, disabled, variant }) => {
  const [rangeValue, setrangeValue] = useState(value ? value : 0);
  const handleRangeSlider = (e, isEnded=false) => {
    setrangeValue(e);
    onChange([e], isEnded);
  };

  return (
    <Slider
      aria-label="slider-ex-3"
      defaultValue={30}
      orientation="vertical"
      colorScheme="primary"
      //   className="tldr-slider"
      step={0.1}
      value={rangeValue}
      onChange={(e) => handleRangeSlider(e)}
      onChangeEnd={(e) => handleRangeSlider(e, true)}
      disabled={disabled}
      min={0}
      max={100}
      variant={variant}
      reversed
      mr="1"
    >
      <SliderTrack>
        <SliderFilledTrack />
      </SliderTrack>
      <SliderThumb />
    </Slider>
  );
};

ChakraVolumeSlider.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  variant: PropTypes.string,
};

export default ChakraVolumeSlider;
